export default customElements.define('w-grid', class Grid extends wealthify.CustomElementBaseClass {

    constructor() {
        const styleSelector = 'o-grid';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `<div class="${styleSelector}__container" data-root></div>`,
            hasChildren: true
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get validHoziontalAlignments () {
        return [ 'left', 'right', 'center' ];
    }

    static get validLayouts () {
        return [ 'stacked', 'stacked-reverse', 'inline', 'inline-reverse' ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('collapsed', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('layoutmobile', {type: wealthify.propTypes.ArrayItem(this.validLayouts)}),
            new wealthify.Prop('layouttablet', {type: wealthify.propTypes.ArrayItem(this.validLayouts)}),
            new wealthify.Prop('layoutdesktop', {type: wealthify.propTypes.ArrayItem(this.validLayouts)}),
            new wealthify.Prop('layoutwide', {type: wealthify.propTypes.ArrayItem(this.validLayouts)}),
        ];
    }

    get propCallbacks () {
        return {
            collapsed: () => {
                const classListAction = this.collapsed ? 'add' : 'remove';

                this.dom.root.classList[classListAction](`${this.styleSelector}__container--collapsed`);
            },
            layoutmobile: () => {
                this._updateLayout('mobile', this.layoutmobile);
            },
            layouttablet: () => {
                this._updateLayout('tablet', this.layouttablet);
            },
            layoutdesktop: () => {
                this._updateLayout('desktop', this.layoutdesktop);
            },
            layoutwide: () => {
                this._updateLayout('wide', this.layoutwide);
            },
        };
    }

    _updateLayout (breakpoint, value) {
        this.constructor.validLayouts.forEach((key) => {
            this.dom.root.classList.remove(`${this.styleSelector}__container--layout-${breakpoint}-${key}`);
        });

        this.dom.root.classList.add(`${this.styleSelector}__container--layout-${breakpoint}-${value}`);
    }

});